// @mui
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
// theme
import { hideScroll } from 'src/theme/css';

// components
import { NavSectionMini } from 'src/components/nav-section';
//
import { NAV } from '../config-layout';
import { useNavDataVertical } from './config-navigation';
import { NavToggleButton } from '../_common';
import SiherLogo from 'src/assets/seal-siher.png';
import { getUser } from 'src/auth/context/jwt/utils';

// ----------------------------------------------------------------------

export default function NavMini() {
  const { user } = getUser();

  const renderLogo = (
    <img
      src={SiherLogo}
      alt="Siher Logo"
      style={{
        zIndex: 9,
        width: '40px',
        margin: 5,
        marginLeft: 25,
      }}
    />
  );
  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_MINI },
      }}
    >
      <NavToggleButton
        sx={{
          top: 22,
          left: NAV.W_MINI - 12,
        }}
      />

      <Stack
        sx={{
          pb: 2,
          height: 1,
          position: 'fixed',
          width: NAV.W_MINI,
          borderRight: (theme) => `dashed 1px ${theme.palette.divider}`,
          ...hideScroll.x,
        }}
      >
        {renderLogo}

        <NavSectionMini
          config={{
            currentRole: user?.role || 'admin',
          }}
        />
      </Stack>
    </Box>
  );
}
